export default function getDistance(
  kilometres: number,
  displayUnit: "metric" | "imperial" = "metric",
) {
  if (displayUnit === "imperial") {
    const feet = Math.round(kilometres * 3280.84);
    if (feet <= 1056) return `${feet} ft`;

    const miles = (kilometres * 0.621371).toFixed(1);
    return `${miles} mi`;
  }

  const meters = Math.round(kilometres * 1000);
  if (meters < 1) return "<1 m";
  if (meters < 1000) return `${meters} m`;
  return `${kilometres.toFixed(1)} km`;
}
